<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
              v-model="listQuery.businessNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务名称</span>
            <el-input
              v-model="listQuery.businessName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务品牌</span>
            <el-input
              v-model="listQuery.businessBrand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务型号</span>
            <el-input
              v-model="listQuery.businessModel"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">客户公司</span>
            <el-input
              v-model="listQuery.customerCompany"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务员</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">开票状态</span>
            <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" @change="handleFilter" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in statusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t('table.search') }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t('table.add') }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t('table.reset') }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
          <span class="ml-10 filter-mark">
            <span class="status-item"><span class="status-square" style="background-color: red;"></span><span class="status-text">待开票/部分开票</span></span>
            <span class="status-item"><span class="status-square" style="background-color: #999;"></span><span class="status-text">已作废</span></span>
            <span class="status-item"><span class="status-square" style="background-color: rgb(188, 188, 9);"></span><span class="status-text">待确认作废</span></span>
            <span class="status-item"><i class="iconfont icon-tubiao-40" style="margin-right: 5px;" /><span class="status-text">有备注信息</span></span>
            <span class="status-item"><i class="iconfont icon-tubiao-40 cell-blue" style="margin-right: 5px;" /><span class="status-text">资料有修改</span></span>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="el => { if (el) tableListRef[0] = el }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="true"
              :showSummary="true"
              :isShowPagination="false"
              :handleDefaultWidth="140"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :canRefresh="false"
              :canChangeColumn="false"
              style="height:100% ;overflow:hidden;"
              :tableRowClassName="tableCellClassName"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:no="scope">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.mark"
                  placement="top-start"
                  v-if="scope.row.mark"
                >
                  <i class="iconfont icon-tubiao-40" ></i>
                </el-tooltip>
                <span v-if="scope.row.applyCancelStatus === 1" class="color-cancle">{{scope.row.applyCancelStatus === 1 ? '申请作废' : ''}} </span>
                <span v-if="scope.row.status === 2" class="color-cancle">{{scope.row.status === 2 ? '申请退回' : ''}} </span>
                <span :class="tableCellClassName(scope)">{{scope.row.no}} </span>
              </template>
              <template v-slot:operation-action="scope">
                <CommandRender
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li
                    v-for="item in tabList"
                    :key="item.id"
                    :class="{ active: activeTab === item.id }"
                    @click="handleTabClick(item)">{{ item.name }}
                  </li>
                </ul>
              </div>
              <TraceInfo v-if="activeTab === 3" ref="TraceInfo" :id="activeId" api="invoice"/>
              <InvoiceNumber
                v-if="activeTab === 4"
                ref="InvoiceNumber"
                :id="activeId"
                :api="`invoice/${activeId}/actions/detail`"
              />
              <BusinessInfo v-if="activeTab === 2" ref="TraceInfo" :id="activeId" api="invoice"/>
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :dialogFormVisible="dialogFormVisible"
      api="invoice"
      :canSubmit="commandType !== 'look'"
      :handleResolveTempData="handleResolveTempData"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <el-button
      type="primary"
      circle
      @click="handleSubMenuCollapse"
      class="subMenuCollapseBtn"
      v-if="!dialogFormVisible"> {{ isSubMenuCollapse ? '展开' : '收起' }}
    </el-button>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, reactive, toRefs, onMounted, nextTick, ref, watch } from 'vue'
import { ElMessage, ElMessageBox, ElForm } from 'element-plus'
import { deleteById, getPageList } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { UsersModel } from '@/model/userModel'
import { ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/views/invoice/From.vue'
import TableList from '@/components/common/TableList.vue'
import TraceInfo from '@/components/traceInfo/Index.vue'
import BusinessInfo from '@/views/order/businessInfo/Index.vue'
import InvoiceNumber from '@/views/business/businessList/InvoiceNumber/Index.vue'

import { TableName, permissionName } from '@/utils/enum'
import { TableField } from '@/views/invoice/FieldTable'
import mixin from '@/mixins/index'
import CommandRender from '@/components/common/CommandRender.vue'

import { defaultDate, pageVo, pageSizes } from '@/utils/index'
import { useI18n } from 'vue-i18n'
import { cancelTicket, applyBackTicket } from '@/apis/invoice'

export default defineComponent({
  name: 'Invoiceorder',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    TraceInfo,
    BusinessInfo,
    CommandRender,
    InvoiceNumber
  },
  setup() {
    const { t } = useI18n()
    const dataForm = ref(ElForm)
    const tableListRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_INVOICE_ORDER,
      permissionName: permissionName.INVOICE_ORDER,
      columnAllData: TableField,

      activeId: 0,
      activeRate: 0,
      activeRow: {},
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        businessNo: undefined,
        businessName: undefined,
        businessBrand: undefined,
        businessModel: undefined,
        customerCompany: undefined,
        salesManId: undefined,
        status: undefined,
        startTime: '',
        endTime: '',
        ...pageVo
      },
      dialogFormVisible: false,
      statusOption: [],
      salesManOption: [],

      pageSizes,
      tabList: [
        {
          name: '业务信息',
          id: 2
        },
        {
          name: '发票号码',
          id: 4
        }
        // {
        //   name: '跟踪信息',
        //   id: 3
        // }
      ],
      newHpx: 0,
      activeTab: 2,
      dengjiVisible: false,
      djInfoVisible: false,
      DJTableData: [],
      btnList: [],
      ruleForm: {
        invoiceNumber: '',
        no: '',
        code: '',
        checkCode: '',
        amount: 0,
        date: ''
      },
      rules: {
        invoiceNumber: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        no: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        code: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        amount: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        checkCode: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        date: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }]
      },
      commandType: '',
      handleCommand(command: string, val?: any) {
        console.log(command, 'command')
        dataMap.commandType = command
        dataMap.activeId = val ? val.id : 0
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'look':
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'cancel-ticket':
            dataMap.cancelTicket(val)
            break
          case 'apply-back-ticket':
            dataMap.handleApplyBackTicket(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        // invoice/page
        getPageList('invoice', {
          ...dataMap.listQuery,
          pageType: 1
        }).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          businessNo: undefined,
          businessName: undefined,
          businessBrand: undefined,
          businessModel: undefined,
          customerCompany: undefined,
          salesManId: undefined,
          status: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const {
          startTime,
          endTime
        } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.dialogFormVisible = true
      },

      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('invoice', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleResolveTempData(tempModel: any) {
        const { model } = tempModel
        tempModel.model = model ? model.join(',') : ''
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/InvoiceStatus').then((res: any) => {
          dataMap.statusOption = res ? res.filter((k: any) => ![-1, 2].includes(k.id)) : []
        })
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      },
      cancelTicket(val: any) {
        ElMessageBox.prompt(
          '申请作废发票理由：',
          '申请作废',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            cancelButtonClass: 'el-button--danger'
          }
        ).then((params: any) => {
          const { value } = params
          cancelTicket(val.id, value).then(() => {
            dataMap.getList()
            ElMessage({
              message: '已提交申请，请等待财务人员审批！',
              type: 'success',
              duration: 1000
            })
          })
        })
      },
      tableCellClassName({ row }: any) {
        const obj = {
          待开票: 'row-red',
          部分开票: 'row-red',
          已作废: 'row-gray',
          待确认作废: 'row-yellow'
        }

        return obj[row.statusValue] || ''
      },
      handleApplyBackTicket(row: any) {
        ElMessageBox.prompt(
          '申请退回发票理由：',
          '提交',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            cancelButtonClass: 'el-button--danger'
          }
        ).then((params: any) => {
          const { value } = params
          applyBackTicket(row.id, { comment: value }).then(() => {
            dataMap.getList()
            ElMessage({
              message: '已提交申请，请等待财务人员审批！',
              type: 'success',
              duration: 1000
            })
          })
        })
      }
    })
    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./order/invoiceInfo',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    onMounted(() => {
      mixinData.initHeight()

      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
      dataMap.btnList = [
        {
          pkey: `${dataMap.permissionName}_EDIT`,
          name: '查看',
          command: 'look'
        },
        {
          pkey: `${dataMap.permissionName}_EDIT`,
          name: '编辑',
          command: 'edit',
          visible: (row: any) => {
            return row.status === 0
          }
        },
        {
          pkey: `${dataMap.permissionName}_BACK`,
          name: '申请退回',
          command: 'apply-back-ticket',
          visible: (row: any) => {
            return row.status === 1
          }
        },
        {
          pkey: `${dataMap.permissionName}_CANCEL`,
          name: '申请作废',
          command: 'cancel-ticket',
          visible: (row: any) => {
            return [3, 4].includes(row.status) && row.applyCancelStatus !== 1
          }
        },
        {
          pkey: `${dataMap.permissionName}_DELETE`,
          name: '删除',
          command: 'delete',
          type: 'danger',
          visible: (row: any) => {
            return row.status === 0
          }
        }
      ]
    })
    return {
      t,
      ...toRefs(dataMap),
      dataForm,
      ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse,
      tableListRef
    }
  }
})
</script>
<style lang="scss">

</style>
